import { BASE_URL } from "@/services/api/base";

export const getCompanyEndpoint = `${BASE_URL}/Company/Get`;
